// extracted by mini-css-extract-plugin
export default {"notifications__bell":"notifications__bell--3fc_s","notifications__bell__icon":"notifications__bell__icon--vpAJm","notifications__bell--active":"notifications__bell--active--3WqKm","spin":"spin--14IbI"};
    if(module.hot) {
      // 1747648189245
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  